<template>
  <v-dialog v-model="showModal" persistent max-width="450px">
    <template v-slot:activator="showModal">
      <slot></slot>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Créer une nouvelle Coopérative</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="cooperative"
                label="Nom de la coopérative"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeModal">Fermer</v-btn>
        <v-btn color="blue darken-1" text @click="createAndClose"
          >Créer la coopérative</v-btn
        >
      </v-card-actions>
      <div v-if="loading" class="message" :class="message.class">
        <span>
          {{ message.value }}
        </span>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapActions, mapState } from 'vuex';
export default {
  name: 'CoopForm',
  props: {
    showModal: Boolean,
  },
  data() {
    return {
      cooperative: null,
      loading: false,
      message: {
        value: 'Création en cours...',
        class: 'loading',
      },
    };
  },
  computed: {
    ...mapState({
      userEmail: 'user',
    }),
  },
  methods: {
    ...mapActions(['setCooperatives']),
    initData() {
      this.cooperative = null;
      this.loading = false;
      this.message = {
        value: 'Création en cours...',
        class: 'loading',
      };
    },
    closeModal(data) {
      this.$emit('closeModal', data || {});
      this.initData();
    },
    createAndClose() {
      this.loading = true;
      axios({
        method: 'post',
        url:
          process.env.VUE_APP_BASE_URL + process.env.VUE_APP_REF_COOPERATIVES,
        headers: {
          'Content-Type': 'application/json',
          user: this.userEmail,
        },
        data: {
          nom: this.cooperative,
        },
      })
        .then(result => {
          this.setCooperatives();
          setTimeout(() => {
            this.message = {
              class: 'success',
              value: `La Coopérative à été crée !`,
            };
            const that = this;
            setTimeout(() => {
              that.closeModal({ cooperative: result.data });
            }, 3000);
          }, 1500);
        })
        .catch(() => {
          setTimeout(() => {
            this.message = {
              class: 'error',
              value: 'Une erreur est survenue...',
            };
            const that = this;
            setTimeout(() => {
              that.initData();
            }, 3000);
          }, 500);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.message {
  width: 100%;
  height: 0;
  color: #ffffff;
  font-weight: 600;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease, height 0.3s ease;
  &.loading {
    background: #2888ff;
    height: 50px;
  }
  &.success {
    background: #2cff95;
    height: 50px;
  }
  &.error {
    background: #ff614e;
    height: 50px;
  }
}
</style>
